import ReactDOM from 'react-dom';
import React from 'react';
import { AppContextProvider } from '../../Services/AppContext';
import { loadDOMComponent } from '../../helpers';
import Modal from './Modal';
import Button from '../Base/Button/Button';
import DomModal from './DomModal';

loadDOMComponent({
	selector: 'react-modal',
	callback: ({ container }) => {
		let xxx = undefined;
		const opened = false;

		container.addEventListener('toggle', () => {
			if (xxx) {
				xxx(!opened);
			}
		});

		const openedCallback = x => {
			xxx = x;
		};

		ReactDOM.render(
			<AppContextProvider>
				<DomModal openedCallback={openedCallback} />
			</AppContextProvider>,
			container,
		);
	},
});
